<template>
  <div v-if="visibleReminders.length">
    <div class="mb-4 text-headline-xs">{{ t('Reviews.agency.review.history.title') }}</div>
    <AgencyReminderItem
      v-for="reminder in visibleReminders"
      :key="reminder.id"
      :author-name="authorName"
      :reminder="reminder"
      class="mb-4"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import AgencyReminderItem from './AgencyReminderItem.vue'
import type { UniversalReviewReminder } from './types'

const props = defineProps<{
  authorName?: string
  reminders: UniversalReviewReminder[]
}>()

const { t } = useI18n()

const sortKey = (reminder: UniversalReviewReminder) => reminder.sentAt ?? ''

const visibleReminders = computed(() => props.reminders.slice().sort((a, b) => sortKey(a).localeCompare(sortKey(b))))
</script>
